import PropTypes from 'prop-types';
import React, { Component } from "react";
import styled from 'styled-components';
import Spinner from '@atlaskit/spinner';
import ProgressBar from '@atlaskit/progress-bar';
import {Group, Item} from '@atlaskit/navigation-next';
import {Link} from 'react-router-dom';
import Button from '@atlaskit/button';
import SearchIcon from '@atlaskit/icon/glyph/search';
import {Trans, withTranslation} from 'react-i18next';

const SearchResultContainer  = styled.div`
  margin-bottom: 64px
`;

const SpinnerContainer = styled.div`
  padding: 12px;
  padding-top: 64px;
  text-align: center;
`;

const ProgressBarContainer = styled.div`
  padding: 12px;
`;

const EmptyMessage = styled.p`
  padding: 12px;
  padding-top: 24px;
`;

const SearchInput = styled.input`
  border: none;
  display: block;
  font-size: 24px;
  font-weight: 200;
  outline: none;
  padding: 0 0 0 12px;
`;

const ItemContainer = styled.div`
  padding: 12px;
  &:hover {
    background-color: rgba(23, 43, 77, 0.04);
  }
  a:hover, a:visited, a:link, a:active {
    text-decoration: none;
  }
`
const ItemTitle = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.01px;
  color: #172B4D;
`;

const ItemSubtitle = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: #8993A4;
`;

const TYPE_NAMES = {
  dealers: <Trans>Dealers</Trans>,
  clients: <Trans>Clients</Trans>,
  users: <Trans>Users</Trans>
}

class SearchDrawer extends Component {
  static propTypes = {
    hideMoreButton: PropTypes.bool,
    query: PropTypes.string,
    data: PropTypes.object,
    fetching: PropTypes.bool,
    onSearch: PropTypes.func,
    onResultClicked: PropTypes.func,
  };
  
  static defaultProps = {
    fetching: false,
    hideMoreButton: false,
    onSearch: value => console.log('SearchDrawer_onSearch', value),
    onResultClicked: () => console.log('SearchDrawer_onResultClicked'),
  }

  constructor(props){
    super(props);
    this.timeout =  0;
  }

  onSearchTextChange = e => {
    const searchText = e.target.value;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      searchText && this.props.onSearch(searchText);
    }, 1000);
  }

  renderSearchItemResult = (type, data) => {
    let subText;
    switch (type) {
      case 'users':
        subText = data.dealer && `${data.dealer.name}, ${data.dealer.city.name}, ${data.dealer.city.region.name}`
        break;
      case 'dealers':
        subText = data.city && `${data.city.name}, ${data.city.region.name}`;
        break;
      default:
        break;
    }
    return (
      <ItemContainer key={`group_${type}_${data.id}`}>
        <Link
          onClick={this.props.onResultClicked}
          to={`/${type}/${data.id}`}>
            <ItemTitle>{data.fullName || data.name}</ItemTitle>
            {subText && <ItemSubtitle>{subText}</ItemSubtitle>}
        </Link>
      </ItemContainer>
    )
  }

  renderSearchResult() {
    const {data, fetching, hideMoreButton} = this.props;

    if (data) {
      if (Object.keys(data).length > 0) {
        return (
          <SearchResultContainer>
            {fetching && <ProgressBarContainer><ProgressBar isIndeterminate/></ProgressBarContainer>}
            {Object.keys(data).map(key => (
              <Group key={`group_${key}`} heading={TYPE_NAMES[key] ? TYPE_NAMES[key] : key}>
                {data[key].map(itm => this.renderSearchItemResult(key, itm))}
              </Group>
            ))}
            {!hideMoreButton && (
              <Button
                style={{marginTop: 24}}
                appearance='subtle'
                iconBefore={<SearchIcon/>}
                component={React.forwardRef((props, ref) => (
                  <Link
                    {...props}
                    ref={ref}
                    to={`/search`}
                    onClick={this.props.onResultClicked}>
                    {props.children}
                  </Link>
                ))}
              >
                <Trans>Show all results</Trans>
              </Button>
            )}
          </SearchResultContainer>
        );
      } else if (!fetching) {
        return this.props.query ? <EmptyMessage><Trans>Nothing found</Trans></EmptyMessage> : null;
      }
    } else if (fetching) {
      return (<SpinnerContainer><Spinner size="medium" /></SpinnerContainer>)
    }
    
    return null;
  }

  render() {

    return (
      <div style={{marginTop: 46, paddingRight: 24}}>
        <SearchInput
          defaultValue={this.props.query}
          type='text'
          placeholder={`${this.props.t("Search")}...`}
          onChange={this.onSearchTextChange}
        />
        <div>
          {this.renderSearchResult()}
        </div>
      </div>
    );
  }
}

export default withTranslation('common')(SearchDrawer);